import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { AuthReducerState } from 'store/reducers/auth.reducer';
import { IUser } from 'modules/core/types';
import { DealSourceProvider } from 'modules/core/enums';

export const getAuthState = (state: RootState): AuthReducerState => state.auth;

export const getUser = createSelector(getAuthState, ({ user }): IUser | null => {
  if (user) {
    return {
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      dealer: user.dealer,
      phoneNumber: user.phone_number,
      role: user.role,
      tenant: user.tenant,
      hasExecutiveAccess: user.has_executive_access,
      tenants: user.tenants,
      isWithInventory: user.with_inventory,
      is_sso: user.is_sso,
      sso_type: user.sso_type,
      dealSource: user.deal_source ?? DealSourceProvider.ROUTE_ONE,
      isAlternativeSso: user.is_alternative_sso,
      rateSheetsData: user.rate_sheets_data,
      routeOneUserId: user.r1_user_id,
      sessionTrackingId: user.session_tracking_id,
      lenderSettings: user.lender_settings_data,
      hasPaymentOption: user.has_payment_option,
      originalConversationId: user.original_conversation_id,
      originalExternalDealerId: user.original_external_dealer_id,
      originalExternalLenderId: user.original_external_lender_id,
      foureyesWebsiteId: user.foureyes_website_id,
      withWholesaleInventory: user.with_wholesale_inventory,
      afgDealerId: user.afg_dealer_id ?? null,
      gamificationEnabled: Boolean(user.gamification_enabled),
      gamificationLenderScope: user.gamification_lender_scope ?? null,
      gamificationRacInScope: Boolean(user.gamification_rac_in_scope),
    };
  }

  return null;
});

export const getIsGamificationEnabled = createSelector(getUser, (user) => Boolean(user?.gamificationEnabled));

export const getGamificationLenderScope = createSelector(
  getUser,
  (user): number[] | null => user?.gamificationLenderScope ?? null,
);

export const getGamificationRacInScope = createSelector(getUser, (user) => Boolean(user?.gamificationRacInScope));
